import React from "react";
import styled from "styled-components";
import { useTheme } from "styled-components";
import { ThemedText } from "@components/ThemedText";
import { cardStroke } from "@styles/cardStroke";
import RightIcon from "@icon-park/react/es/icons/Right";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.ui.background.raised};
  ${cardStroke}
  border-radius: 8px;
  cursor: pointer;
`;

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

interface MoveToIsaCardProps {
  onClick: () => void;
  testID?: string;
}

export const MoveToIsaCard = ({
  onClick,
  testID = "move-to-isa-card",
}: MoveToIsaCardProps) => {
  const theme = useTheme();

  return (
    <Container
      data-testid={testID}
      role="button"
      tabIndex={0}
      aria-label="Move funds to your IF-ISA"
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <TextColumn>
        <ThemedText type="U16" color="SLATE700">
          Move funds to your IF-ISA
        </ThemedText>
        <ThemedText type="P14" color="SLATE600">
          Move your personal Cur8 investments into your IF-ISA investments.
        </ThemedText>
      </TextColumn>
      <RightIcon size={24} fill={theme.colors.ui.icon.secondary} />
    </Container>
  );
};
